import axios from "axios";

export const zendeskEfileApi = axios.create();
